import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidatorService } from '../../../../services';
import { Utils } from '../../../../utils';
import { MessageService } from 'primeng/api';
import { ValidatorsConfigComponent } from '../config.component';

@Component({
  selector: 'app-config-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})

export class ValidatorConfigListComponent implements OnInit {

  limit = 12;
  configs = [];
  sub: any;
  id: any;

  constructor(
    private validatorService: ValidatorService,
    private route: ActivatedRoute,
    private utils: Utils,
    private messageService: MessageService,
    private router: Router,
    public parent: ValidatorsConfigComponent
  ) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = params['id'];

      this.validatorService.getValidationConfigsByProvider(this.id).subscribe(data => this.configs = data);
    });
  }

  deleteRow(config): void {
    if (confirm('Czy chcesz usunąć konfigurację walidacji?')) {
      this.validatorService.deleteValidationConfig(config.id)
        .subscribe(
          () => {
            let idx = this.configs.findIndex(value => value.id == config.id);
            this.configs.splice(idx, 1);
            this.messageService.add({ severity: 'success', summary: 'Usunięto konfigurację walidacji' });
          },
          error => {
            this.messageService.add({ severity: 'error', summary: 'Nie usunięto konfiguracji walidacji', detail: this.utils.handleError(error) });
          }
        );
    }
  }

  gotoEdit(config): void {
    localStorage.setItem('currentValidationConfiguration', JSON.stringify(config));
    this.router.navigate(['./' + config.id], { relativeTo: this.route });
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
